export const LAYER_TYPE = {
  COUPON: 'COUPON',
  DISCOUNT: 'DISCOUNT',
  CART_DISCOUNT: 'CART_DISCOUNT',
  FREE_GIFT_CONDITION: 'FREE_GIFT_CONDITION',
} as const;

export const FREE_GIFT_FAIL_REASON = {
  TARGET_PRODUCT_CHANGED: '주문상품 지급 대상 상품에서 제외',
  PARTNER_PROMOTION_DISAGREE: '대상상품 파트너 프로모션 미동의',
  PRODUCT_PROMOTION_DISAGREE: '대상상품 상품 프로모션 미동의',
  FREE_GIFT_CONDITION_FAIL: '사은품 지급조건 미달성',
  FREE_GIFT_PARTNER_PROMOTION_DISAGREE: '사은품 파트너 프로모션 미동의',
  FREE_GIFT_PROMOTION_DISAGREE: '사은품 상품 프로모션 미동의',
  FREE_GIFT_STATUS_UNABLE_TO_GIVE: '사은품 지급불가 상태'
}
